import React from "react";

import { cn } from "../../../common/u1/cn";
import { Button } from "../../../common/u1/Button";
import { PlusIcon } from "../../../../assets/ui/icons";

/* The dashed "Add your …" bar every list section carries above its cards. */
export const SectionAddBar = ({
  prompt,
  label,
  onAdd,
  disabled = false,
  className = "",
}) => (
  <div
    className={cn(
      "flex flex-wrap items-center justify-between gap-3",
      "rounded-[12px] border border-dashed border-[var(--line-2)]",
      "bg-[var(--field-inset)] px-4 py-3",
      className
    )}
  >
    <p className="m-0 text-[13px] font-semibold text-[var(--ink-2)] font-sans">
      {prompt}
    </p>
    <Button
      variant="coralSolid"
      size="sm"
      className="gap-1.5"
      onClick={onAdd}
      disabled={disabled}
    >
      <PlusIcon size={13} />
      {label}
    </Button>
  </div>
);

export default SectionAddBar;
